import React, { useEffect, useRef, useState } from 'react';
import { Editor as MonacoEditor } from '@monaco-editor/react';
import _ from 'lodash';

type CodeEditorProps = {
  language?: string,
  width?: string,
  height?: string,
  onChange?: (value: string) => void,
  onMount?: (editor, monaco) => void,
  value: string
};

export const CodeEditorComponent: React.FC<CodeEditorProps> = ({
  language = 'javascript',
  width = '100%',
  height = '650px',
  onChange,
  onMount,
  value,
  options = {},
  disabled = false
}) => {
  const containerRef = useRef();
  const editorRef = useRef();
  const [heightState, setHeight] = useState(height);

  const handleMount = (editor, monaco) => {
    editorRef.current = editor;
    updateHeight();
    onMount && onMount(editor, monaco);
  };
  const handleChange = _.debounce((value: string) => {
    if (onChange) {
      onChange(value);
    }
  }, 1000);

  useEffect(() => {
    window.addEventListener('resize', updateHeight);
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateHeight = () => {
    // const contentHeight = Math.min(1000, editorRef.current.getContentHeight());
    containerRef.current.style.width = `${width}px`;
    // containerRef.current.height = `${contentHeight}px`;
    editorRef.current.layout({ width, height: containerRef.current.height });
    setHeight(containerRef.current.height);
  };

  const editorClassName = disabled ? 'disabled-editor' : '';

  return (
    <div style={{ width, height: '100%' }} ref={e => (containerRef.current = e)}>
      <MonacoEditor
        theme="vs-dark"
        language={language}
        width={width}
        height={heightState}
        value={value}
        options={{
          ...options,
          selectOnLineNumbers: true,
          formatOnType: true,
          automaticLayout: true,
          scrollBeyondLastLine: false
        }}
        onChange={handleChange}
        className={editorClassName}
        onMount={handleMount}
      />
    </div>
  );
};
